import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	save: {
		id: 'servicedesk-sla-settings.common.footer.save',
		defaultMessage: 'Save',
		description: 'Button to save calendar',
	},
	cancel: {
		id: 'servicedesk-sla-settings.common.footer.cancel',
		defaultMessage: 'Cancel',
		description: 'Button to cancel',
	},
});
